import { IPropertyPresentable, IPropertyEditable } from "../../../../base/domain/system/edit";
import { GraphKinds, IRangeOfMotionBehavior, ILineGraphBehavior } from "../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { IGraphObject } from "../objects";
import { AbstractRectangleCoordinatableObjectEditor } from "./AbstractRectangleCoordinatableObjectEditor";

export class GraphObjectEditor extends AbstractRectangleCoordinatableObjectEditor<IGraphObject> {
  constructor(source: IGraphObject | GraphObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._name = this.createNamePropertyEditor(s => s.kind === GraphKinds.Line);
    this._nameHistories = this.createNameHistoriesPropertyEditor(s => s.kind === GraphKinds.Line);
    this._bookmark = this.createBookmarkPropertyEditor(s => s.kind === GraphKinds.Line);
    this._kind = this.createPropertyPresenter(s => s.kind);
    this._rangeOfMotionBehavior = this.createPropertyEditor(
      s => s.behavior as IRangeOfMotionBehavior,
      (s, v) => s.behavior = v,
      s => s.kind === GraphKinds.RangeOfMotion);
    this._lineGraphBehavior = this.createPropertyEditor(
      s => s.behavior as ILineGraphBehavior,
      (s, v) => s.behavior = v,
      s => s.kind === GraphKinds.Line);
    this._rangeOfMotionGroupKey = this.createNamePropertyEditor();
    }

  protected _kind: IPropertyPresentable<GraphKinds>;
  protected _rangeOfMotionBehavior: IPropertyEditable<IRangeOfMotionBehavior>;
  protected _lineGraphBehavior: IPropertyEditable<ILineGraphBehavior>;
  protected _rangeOfMotionGroupKey: IPropertyEditable<string>;

  kind(): IPropertyPresentable<GraphKinds> {
    return this._kind;
  }

  rangeOfMotionBehavior(): IPropertyEditable<IRangeOfMotionBehavior> {
    return this._rangeOfMotionBehavior;
  }

  lineGraphBehavior(): IPropertyEditable<ILineGraphBehavior> {
    return this._lineGraphBehavior;
  }

  getLineGraphValueTypes(): string[] {
    return this._specification.objects.graph.valueTypes;
  }

  rangeOfMotionGroupKey(): IPropertyEditable<string> {
    return this._rangeOfMotionGroupKey;
  }

  private get isRangeOfMotion(): boolean {
    return this.kind().getValue() === GraphKinds.RangeOfMotion;
  }

  getTypeName(): string {
    return this.isRangeOfMotion
      ? "関節可動域"
      : "折れ線グラフ";
  }

  clone(): IFormatObjectEditable {
    return new GraphObjectEditor(this);
  }
}
